import type { ScenarioLocation, ScenarioOrder } from './planningData';
import { isDefined } from './util';

export function getPortName(
  port: Pick<ScenarioLocation, 'name' | 'country' | 'locode'> | null,
): string {
  if (!port) {
    return 'No port';
  }
  const { name, country, locode } = port;
  return [name, country, locode].filter(Boolean).join(', ');
}

export function getVoyageCharterIdsFromOrders(orders: ScenarioOrder[]) {
  const incomingVoyageCharterIds = new Set<number>();
  const outgoingVoyageCharterIds = new Set<number>();

  orders.forEach((o) => {
    const incomingVcId = o.incomingVoyageCharterRelation?.voyageCharterId;
    const outgoingVcId = o.outgoingVoyageCharterRelation?.voyageCharterId;

    if (isDefined(incomingVcId)) {
      incomingVoyageCharterIds.add(incomingVcId);
    }

    if (isDefined(outgoingVcId)) {
      outgoingVoyageCharterIds.add(outgoingVcId);
    }
  });

  return { incomingVoyageCharterIds, outgoingVoyageCharterIds };
}
